<ng-container *ngIf="flags?.isSearchFormSubmitted && flags?.isLoading; then loading; else loaded"></ng-container>
<ng-template #loading>
  <div class="w-100 text-center">
    <div class="spinner-grow text-primary load m-5" role="status" data-test-id="map-loading-spinner">
      <span class="sr-only">{{ 'LOADING_HINT' | translate }}</span>
    </div>
  </div>
</ng-template>
<ng-template #loaded>
  <div
    *ngIf="markers?.length > 0 || flags?.isSearchFormSubmitted || flags?.isGoToFormSubmitted"
    class="px-1 results-block"
  >
    <h3
      class="ps-1 m-1"
      data-test-id="map-search-block-results-hint"
      [innerHtml]="
        (markers.length === 0 &&
        (this.flags.isInAggregationZoomRange ||
          (this.flags.noResultsFoundGlobally && !this.flags.isInAggregationZoomRange))
          ? 'MAP_SEARCH_NO_RESULTS_HINT'
          : markers.length === 1
            ? 'MAP_SEARCH_ONE_RESULT_HINT'
            : 'MAP_SEARCH_MULTIPLE_RESULTS_HINT'
        ) | translate: { count: searchResultTotalCount }
      "
    ></h3>
    <div class="results-items-block" id="results-items-block">
      <div
        *ngFor="let marker of markers; index as i"
        id="map-search-item-{{ i }}"
        [attr.data-test-id]="'map-search-item-' + i + '-' + marker.id"
        class="p-1"
      >
        <app-map-search-result
          mapSearchResult
          [data]="marker.data"
          [isAdminSession]="isAdminSession"
          [kind]="marker.kind"
          [isLoggedIn]="flags?.isLoggedIn"
          [index]="i"
          [isActive]="i === activeItemIndex"
          (itemClicked)="onItemClick(marker.id, i)"
        ></app-map-search-result>
      </div>
      <div class="search-container-login" *ngIf="isAuthSearch()">
        <h3
          class="ps-1 m-1"
          data-test-id="map-search-block-login-hint"
          [innerHtml]="'LOGIN_SEARCH_MAP' | translate: { route: logInLink }"
        ></h3>
      </div>
    </div>
  </div>
</ng-template>
